import { ORDER_METHODS, RoomServiceLocationType } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'obsługa pokoju',
      [RoomServiceLocationType.TableService]: 'obsługa przy stoliku',
    },
    [ORDER_METHODS.PICKUP]: 'odbiór',
    [ORDER_METHODS.DELIVERY]: 'dostawa',
  },
  errors: {
    draft_validation_failed: 'Uzupełnij adres dostawy przed kontynuowaniem.',
  },
};
